<template>
  <div>
    
    <div class="search">
    <input
        id="search-bar"
        v-model="search"
        class="search-field"
        type="text"
        aria-label="search"
        placeholder="Filter LBEs by name or ZIP code"
        @keyup.enter="filterLBEs();"
      />
      <input
        ref="archive-search-bar"
        type="submit"
        class="search-submit"
        value="Search"
        @click="filterLBEs();"
      />
      <button v-if="search.length > 0" class="clear-search-btn" @click="clearSearch">
        <i class="fas fa-times" />
      </button>
    </div>
    <div v-show="!loading && empty" class="h3 mtm center">Sorry, there are no results.</div>
    <div v-show="loading" class="mtm center">
      <i class="fas fa-spinner fa-spin fa-3x" />
    </div>
    <div v-show="failure" class="h3 mtm center">Sorry, there was a problem. Please try again.</div>
    <table v-show="!empty && !loading && !failure">
      <thead>
        <tr>
          <th class="name table-sort"
          :class="currentSortDir"
          @click="sortByTitle()"><span>Business Entity</span></th>
          <th class="address">Address</th>
        </tr>
      </thead>
      <paginate
        name="filteredListing"
        :list="filteredListing"
        class="paginate-list"
        tag="tbody"
        :per="10"
      >
       <tr v-for="lbe in paginated('filteredListing')" :key="lbe.cartodb_id">
          <td>{{ lbe.business_name }}</td>
          <td>{{ lbe.business_address }} <br>
          {{ lbe.city }} {{ lbe.state }} {{ lbe.zip_code }} </td>
        </tr>
        </paginate>
    </table>
    <paginate-links
      for="filteredListing"
      :async="true"
      :limit="3"
      :show-step-links="true"
      :hide-single-page="true"
      :step-links="{
              next: 'Next',
              prev: 'Previous'
            }"
    />
  </div>
</template>

<script>
import axios from "axios";
import VueFuse from "vue-fuse";
import Vue from "vue";
import VuePaginate from "vue-paginate";

const endpoint = "https://phl.carto.com/api/v2/sql?q=select+*%20from%20registered_local_businesses";

Vue.use(VueFuse);
Vue.use(VuePaginate);


export default {
  name: "LBEListing",
  data: function() {
    return {
      LBEListing: [],
      filteredListing: [],
      loading: false,
      failure: false,
      search: "",
      currentSortDir: "asc",
      paginate: ["filteredListing"],
      searchOptions: {
        shouldSort: false,
        threshold: 0.3,
        keys: ["business_name",
        "business_address",
        "zip_code"],
      },
    };
  },

  mounted() {
    this.fetchData();
  },

  filters: {

  },

  computed: {
    empty() {
      return this.filteredListing.length == 0
    },
  },

  watch: {
    search() {
      this.filterLBEs();
    } 
  },

  methods: {
    fetchData: function() {
      this.loading = true;
      axios
        .get(endpoint)
        .then(response => {
          this.LBEListing = response.data.rows;
          this.filteredListing = this.LBEListing;
          this.sortByTitle();
          this.failure = false;
          this.loading = false;
        })
        .catch(e => {
          console.log(e);
          this.loading = false;
          this.failure = true;
        });
    },

    sortByTitle: function() {
    this.currentSortDir = this.currentSortDir === 'desc' ? 'asc' : 'desc';
     this.filteredListing = this.filteredListing.sort((a,b) => {
        let modifier = 1;
        if(this.currentSortDir === 'asc') {
          modifier = -1;
        }
        if(a.business_name < b.business_name) {
          return -1 * modifier;
        }
        if(a.business_name > b.business_name) {
          return 1 * modifier;
        }
        return 0;
      });
    },

    filterLBEs: async function() {
     this.filteredListing = await this.filterBySearch();

    },

    filterBySearch: async function() {
       if (this.search) {
        return this.$search(this.search, this.LBEListing, this.searchOptions);
      }
      return this.LBEListing;
    },

    clearSearch() {
      this.search = "";
    }

  }
};
</script>

<style>
.paginate-links {
  float:right;
}
 .clear-search-btn {
  position: absolute;
  top: 16px;
  right: 70px;
  padding: 0;
  font-size: 20px;
  background-color: #fff;
  opacity: 0.8;
  z-index: 999;
  cursor: pointer;
  color: rgba(60, 60, 60, 0.5);
 
}

 .clear-search-btn:hover {
    background: transparent;
    color: black;
  }
</style>
